export enum RoughFinish {
	Roughing = 0,
	Finishing = 10
}
